import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getTokens } from "../auth";

const ALLOWED_FOR_ONLY_ADMINS = ["/admin-settings"];
const ALLOWED_UPTO_MANAGER = ["/requests"];
const PrivateRoute = ({ component: Comp, ...rest }) => {
  const values = { ...rest };
  const token = getTokens();
  // Handle ALLOWED_UPTO_MANAGER routs
  if (ALLOWED_UPTO_MANAGER.includes(values.path)) {
    return (
      <Route
        {...rest}
        render={(props) =>
          token &&
          ALLOWED_UPTO_MANAGER.includes(values.path) &&
          (values.currentUserId === 4 || values.currentUserId === 5) ? (
            <Redirect to={"/feed"} />
          ) : token ? (
            <Comp {...rest} {...props} />
          ) : (
            <Redirect to={"/login"} />
          )
        }
      />
    );
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        token &&
        ALLOWED_FOR_ONLY_ADMINS.includes(values.path) &&
        (values.currentUserId === 3 ||
          values.currentUserId === 4 ||
          values.currentUserId === 5) ? (
          <Redirect to={"/feed"} />
        ) : token ? (
          <Comp {...rest} {...props} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};

export default PrivateRoute;
